/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_Primary_ContactInputs */

const en_reports_col_primary_contact = /** @type {(inputs: Reports_Col_Primary_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant / debtor`)
};

const pt_br2_reports_col_primary_contact = /** @type {(inputs: Reports_Col_Primary_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerente / devedor`)
};

/**
* | output |
* | --- |
* | "Claimant / debtor" |
*
* @param {Reports_Col_Primary_ContactInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_primary_contact = /** @type {((inputs?: Reports_Col_Primary_ContactInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_Primary_ContactInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_primary_contact(inputs)
	return pt_br2_reports_col_primary_contact(inputs)
});